export default __webpack_public_path__ + "static/media/e33898de-6302-4756-8f0c-5f6c5218e02e_terms_ru.13a1d917.pdf";